'use client';

import View from '@/components/view';
import ImageGallery from '@/components/gallery';
import Detailed from '@/components/details/card';
import VideoBanner from '@/components/banner/video';
import { Image, LinkIcon } from '@nextui-org/react';
import { Page, Section } from '@/typings/pages';
import { extractSection } from '@/lib/find-section';
import SectionStatic from '@/components/markdown/section-static';

enum SectionType {
  FIRST = 'FIRST',
  SECOND = 'SECOND',
  THIRD = 'THIRD',
  GALLERY = 'GALLERY',
}
type Props = {
  data: Page | null;
};
const AboutClient = ({ data }: Props) => {
  const first = extractSection(data?.section, SectionType.FIRST) as Section;
  const second = extractSection(data?.section, SectionType.SECOND) as Section;
  const third = extractSection(data?.section, SectionType.THIRD) as Section;
  const gallery = extractSection(data?.section, SectionType.GALLERY) as Section;
  return (
    <>
      <VideoBanner
        heading={data?.banner?.heading}
        source={data?.banner?.video as string}
      />
      <View className="section flex flex-col gap-4 sm:gap-24 my-4 sm:my-8">
        <View className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-8 sm:gap-12">
          <View className="grid">
            <SectionStatic content={first?.content} />
          </View>
          <Detailed.Preview
            isZoomed
            src={first?.image}
            className="w-full h-full rounded-xl"
            alt={first?.heading}
          />
        </View>
        {/* Section */}
        <View className="grid grid-cols-1 sm:grid-cols-2 gap-8 sm:gap-12">
          <Detailed.Preview
            isZoomed
            src={second?.image}
            alt={second?.heading}
            className="w-full h-full rounded-xl"
          />
          <View className="flex flex-col gap-2">
            <SectionStatic content={second?.content} />
          </View>
        </View>
        {/* Section */}
        <View className="grid grid-cols-1 sm:grid-cols-2 gap-8 sm:gap-12">
          <View className="flex flex-col gap-2">
            <SectionStatic content={third?.content} />
          </View>
          <View>
            <Image
              src={third?.image}
              alt={third?.heading}
              width={600}
              height={600}
              className="w-full rounded-xl"
              isZoomed
            />
          </View>
        </View>
        <ImageGallery items={gallery?.images} />
      </View>
    </>
  );
};
export default AboutClient;
